import { Pipe, PipeTransform } from '@angular/core';
import {TariffSize} from "../../../../../tariff";

@Pipe({
  name: 'includesTariffSize',
  standalone: true
})
export class IncludesTariffSizePipe implements PipeTransform {

  transform(value: TariffSize, sizes: TariffSize[]): unknown {
    return sizes.includes(value);
  }

}
